// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-info {
  /* margin: 2rem auto; */
  /* text-align: center; */
  /* max-width: 500px; */
  /* background: #fffdf5; */
  /* border: 1px solid #ddd; */
  /* border-radius: 12px; */
  /* padding: 1.5rem; */
  /* box-shadow: 0 4px 10px rgba(0,0,0,0.1); */
}

.store-info img {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/StoreInfo.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".store-info {\r\n  /* margin: 2rem auto; */\r\n  /* text-align: center; */\r\n  /* max-width: 500px; */\r\n  /* background: #fffdf5; */\r\n  /* border: 1px solid #ddd; */\r\n  /* border-radius: 12px; */\r\n  /* padding: 1.5rem; */\r\n  /* box-shadow: 0 4px 10px rgba(0,0,0,0.1); */\r\n}\r\n\r\n.store-info img {\r\n  width: 100%;\r\n  border-radius: 8px;\r\n  margin-bottom: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
